/* unplugin-vue-components disabled */import script from "./addEditRoleGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./addEditRoleGroup.vue?vue&type=script&setup=true&lang=ts"

import "./addEditRoleGroup.vue?vue&type=style&index=0&id=25136d6c&lang=less"

const __exports__ = script;

export default __exports__